export const USER_LIST_TYPE = "USER_LIST_TYPE";
export const TYPE_LIST_IN_FILTER="TYPE_LIST_IN_FILTER"
export const ALL_CUSTOMERS_LIST="ALL_CUSTOMERS_LIST"
export const ALL_PROJECTS_LIST="ALL_PROJECTS_LIST"
export const ALL_STATE_LIST="ALL_STATE_LIST"
export const PER_DIEM_LIST="PER_DIEM_LIST"
export const PAGE_OFFSET="PAGE_OFFSET"
export const USER_ACTIVE_TYPE = "USER_ACTIVE_TYPE";
export const CHECK_USER = "CHECK_USER";
export const BILLING_STATEMENT_SELECT = 'BILLING_STATEMENT_SELECT'
export const ADMIN_BILLING_STATEMENT_SELECT = 'ADMIN_BILLING_STATEMENT_SELECT'
export const INVOICE_LIST_SELECT = 'INVOICE_LIST_SELECT'
export const CUSTOMER_SELECT_LIST_FILTER = 'CUSTOMER_SELECT_LIST_FILTER'
export const SORT_PARAMS="SORT_PARAMS"
export const CONSOLIDATE_INVOICE_LIST_SELECT = "CONSOLIDATE_INVOICE_LIST_SELECT" 
export const INNER_NOTIFICATION_DETAILS_REUX = "INNER_NOTIFICATION_DETAILS_REUX" 
